import { render, staticRenderFns } from "./ws.vue?vue&type=template&id=a877f076"
import script from "./ws.vue?vue&type=script&lang=js"
export * from "./ws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports